export default "__VITE_ASSET__DbZdWqCh__"